import { FC, SVGAttributes } from "react";

const Przelewy24IconBackground: FC<SVGAttributes<SVGSVGElement>> = ({
  width = 32,
  height = 24,
  ...props
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 34 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <title>Przelewy24</title>
    <path
      d="M4.7461 1.08655H29.2539C31.3175 1.08655 33 2.7976 33 4.92019V21.2529C33 23.3755 31.3175 25.0865 29.2539 25.0865H4.7461C2.68244 25.0865 1 23.3755 1 21.2529V4.92019C1 2.7976 2.68244 1.08655 4.7461 1.08655Z"
      fill="white"
      stroke="#EEEEEE"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.446 8.72C12.2996 8.5782 12.1252 8.46852 11.934 8.398C11.7133 8.31559 11.4853 8.25431 11.253 8.215C10.9958 8.17006 10.7359 8.14266 10.475 8.133C10.288 8.125 10.168 8.125 10.168 8.125H5.706L4 18.427H5.593L6.222 14.611L9.312 14.626C9.312 14.626 10.516 14.675 11.369 14.222C12.222 13.77 12.449 12.742 12.449 12.742C12.449 12.742 12.543 12.36 12.622 11.896C12.7131 11.3363 12.7955 10.7753 12.869 10.213C12.869 10.213 12.891 10.108 12.891 9.943C12.8989 9.62968 12.8266 9.31955 12.681 9.042C12.6175 8.92456 12.5385 8.81624 12.446 8.72ZM11.219 10.538C11.219 10.557 11.077 11.383 10.89 12.363C10.819 12.737 10.53 12.939 10.202 13.01C9.656 13.126 9.068 13.104 9.068 13.104L6.488 13.097L7.056 9.674L9.394 9.681C9.394 9.681 9.551 9.678 9.772 9.681C10.022 9.685 10.355 9.696 10.628 9.734C10.864 9.764 11.051 9.812 11.111 9.887C11.1825 9.98549 11.2242 10.1025 11.231 10.224C11.245 10.388 11.219 10.527 11.219 10.538Z"
      fill="#D13239"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.99 11.735L15.603 11.739L15.7 11.114C15.7 11.114 15.872 9.984 16.258 9.767C16.381 9.697 16.579 9.633 16.808 9.592C17.23 9.517 17.765 9.509 18.203 9.524C18.873 9.547 19.127 9.554 19.807 9.633C20.488 9.711 20.316 10.37 20.316 10.37L20.181 11.353C20.181 11.353 20.121 11.795 19.964 12.068C19.826 12.311 19.444 12.476 19.224 12.547C18.693 12.719 16.874 13.182 16.874 13.182L15.446 13.594C15.446 13.594 14.566 13.848 14.076 14.391C13.7006 14.8127 13.4406 15.3242 13.321 15.876C13.254 16.197 12.876 18.423 12.876 18.423L20.589 18.427L20.847 16.886L14.747 16.893L14.855 16.265C14.855 16.265 14.926 15.617 15.188 15.405C15.27 15.337 15.311 15.247 15.798 15.075C16.089 14.97 17.084 14.705 17.084 14.705L19.384 14.076C19.384 14.076 20.641 13.755 21.135 13.066C21.629 12.382 21.82 11.069 21.82 11.069C21.82 11.069 21.954 9.794 21.85 9.393C21.749 8.993 21.37 8.514 20.91 8.309C20.45 8.103 19.972 7.983 18.584 8.002C17.197 8.021 16.508 8.084 15.805 8.346C15.102 8.604 14.695 9.076 14.436 9.741C14.156 10.373 13.991 11.735 13.991 11.735H13.99ZM28.511 14.6L29.592 8.122H27.677L21.715 14.525L21.445 16.149H26.66L26.278 18.423L27.879 18.427L28.257 16.149L29.734 16.152L30 14.6H28.511ZM26.918 14.604L23.548 14.6L27.651 10.228L26.918 14.604Z"
      fill="#D4D4D4"
    />
  </svg>
);

export default Przelewy24IconBackground;
